import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, type PushMessage } from "../api.js";
import { SERVICE_IDS } from "../constants.js";

export function PushList() {
  const [status, setStatus] = useState<"all" | "pending" | "sent">("all");
  const [service, setService] = useState<string>("");
  const [items, setItems] = useState<PushMessage[]>([]);
  const [error, setError] = useState<string | null>(null);

  async function load() {
    setError(null);
    try {
      const r = await api.listPushMessages({
        status,
        service: service || undefined,
        limit: 100,
      });
      setItems(r.items);
    } catch (e) {
      setError((e as Error).message);
    }
  }

  useEffect(() => {
    void load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <section data-testid="push-list">
      <div className="toolbar" style={{ marginBottom: 16 }}>
        <h1 style={{ margin: 0 }}>push 通知</h1>
        <Link to="/push/new" className="btn">+ 新規投稿</Link>
      </div>
      <form
        className="toolbar"
        onSubmit={(e) => {
          e.preventDefault();
          void load();
        }}
        style={{ marginBottom: 12 }}
      >
        <label>status<select value={status} onChange={(e) => setStatus(e.target.value as typeof status)}>
          <option value="all">all</option>
          <option value="pending">pending</option>
          <option value="sent">sent</option>
        </select></label>
        <label>service<select value={service} onChange={(e) => setService(e.target.value)}>
          <option value="">(すべて)</option>
          {SERVICE_IDS.map((s) => <option key={s} value={s}>{s}</option>)}
        </select></label>
        <button type="submit" className="btn secondary">絞り込む</button>
      </form>
      {error && <div className="error-banner">{error}</div>}
      {items.length === 0 ? (
        <div className="empty-state">該当する push はありません</div>
      ) : (
        <table className="list" data-testid="push-table">
          <thead>
            <tr><th>title</th><th>service</th><th>lang</th><th>scheduled</th><th>sent</th></tr>
          </thead>
          <tbody>
            {items.map((m) => (
              <tr key={m.id}>
                <td><Link to={`/push/${m.id}`}>{m.title}</Link></td>
                <td>{m.service_id}</td>
                <td>{m.lang ?? "—"}</td>
                <td>{new Date(m.scheduled_at).toLocaleString()}</td>
                <td>{m.sent_at ? <span className="pill ok">sent</span> : <span className="pill danger">pending</span>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </section>
  );
}
